import { z } from 'zod';
/**
 * TỆP ĐÍNH KÈM CỦA DỰ ÁN (25/09/2026) — file gốc của thumbnail: PSD, AI, file nén…
 *
 * Ảnh xem trước (JPG/PNG) vẫn đi đường cũ: thu nhỏ còn 640px rồi lưu cùng bản ghi ảnh, để bảng
 * nào cũng vẽ được ngay. Còn file gốc thì KHÔNG mở ra xem được trên web và nặng hàng chục MB, nên
 * nằm trên đĩa như Kho nhạc, tải về qua đường dẫn có kiểm quyền — không ném vào CSDL.
 */
export const PROJECT_FILE_MIME_BY_EXTENSION = {
    psd: 'image/vnd.adobe.photoshop',
    psb: 'image/vnd.adobe.photoshop',
    ai: 'application/postscript',
    eps: 'application/postscript',
    pdf: 'application/pdf',
    zip: 'application/zip',
    rar: 'application/vnd.rar',
    '7z': 'application/x-7z-compressed',
    tif: 'image/tiff',
    tiff: 'image/tiff',
    /** Ảnh tải lên dạng FILE GỐC (chưa thu nhỏ) — vẫn tải về được nguyên bản. */
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
};
export const ALLOWED_PROJECT_FILE_EXTENSIONS = Object.keys(PROJECT_FILE_MIME_BY_EXTENSION).sort();
/** Mã file do máy chủ sinh — 16 ký tự hex, giống Kho nhạc. */
export const PROJECT_FILE_ID_PATTERN = /^[0-9a-f]{16}$/;
export const projectFileUploadQuerySchema = z.object({
    name: z.string().max(200).default(''),
    /** Ngày của file, «DD/MM/YYYY». */
    d: z.string().max(20).default(''),
    /** Folder trong dự án; 0 / vắng mặt = chưa xếp folder. */
    fd: z.coerce.number().int().nonnegative().default(0),
});
export const projectFileParamsSchema = z.object({
    fileId: z.string().regex(PROJECT_FILE_ID_PATTERN, 'Mã file không hợp lệ'),
});
export const projectIdParamsSchema = z.object({
    id: z.coerce.number().int().positive(),
});
//# sourceMappingURL=attachments.js.map